module.exports = __webpack_public_path__ + "static/img/47_phase_function_Paper_PointsHejduk_Prediction.5ba055f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/47_phase_function_Paper_PointsHejduk_Prediction.png
// module id = McY6
// module chunks = 0